var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24304",
    "data-name": "Group 24304",
    transform: "translate(-1138 -736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-vote-rectangle",
    "data-name": "Rectangle 4686",
    transform: "translate(1138 736)",
    fill: "#fff",
    stroke: "#7e7e7e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 20,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon-vote-thumb",
    "data-name": "Path 23286",
    d: "M1.913,10.712H.765A.766.766,0,0,1,0,9.947V4.973a.766.766,0,0,1,.765-.765H1.913a.766.766,0,0,1,.765.765V9.947a.766.766,0,0,1-.765.765M.765,4.973V9.947H1.913V4.973Zm7.7,5.739H4.591A1.149,1.149,0,0,1,3.443,9.564V4.591a.383.383,0,0,1,.112-.27L7.763.112a.382.382,0,0,1,.541,0L8.753.56a1.915,1.915,0,0,1,0,2.705l-.56.56h2.137a1.149,1.149,0,0,1,1.148,1.148v.268A3.433,3.433,0,0,1,11.3,6.331L10.276,9.4A1.91,1.91,0,0,1,8.461,10.712ZM4.208,4.749V9.564a.383.383,0,0,0,.383.383H8.461A1.146,1.146,0,0,0,9.55,9.162l1.024-3.073a2.673,2.673,0,0,0,.138-.847V4.973a.383.383,0,0,0-.383-.383H7.269A.383.383,0,0,1,7,3.938L8.212,2.724a1.149,1.149,0,0,0,0-1.623L8.034.924Z",
    transform: "translate(1143.762 741.144)",
    fill: "#7e7e7e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVote);
export default __webpack_public_path__ + "static/media/icon-vote.5dda98233c35f301784f3929bf397d65.svg";
export { ForwardRef as ReactComponent };